/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'partial-crf': {
    viewBox: '0 0 32 32',
    data: `<path d="M16,1C7.7,1,1,7.7,1,16c0,8.3,6.7,15,15,15c8.3,0,15-6.7,15-15C31,7.7,24.3,1,16,1z M16,3c7.2,0,13,5.8,13,13H3 C3,8.8,8.8,3,16,3z"/>`
  }
})
